import * as React from 'react';
import { connect } from 'react-redux';

// Components
// @ts-ignore
import SubmittingButton from 'components/SubmittingButton';

// Actions
// @ts-ignore
import { deletePerson as requestDeletePerson } from 'services/people/actions';

interface IOwnProps {
    personId: number;
}

interface IStateProps {}

interface IDispatchProps {
    requestDeletePerson: Function;
}

export interface IProps extends IOwnProps, IStateProps, IDispatchProps {}

export class PersonDeleteModalButton extends React.PureComponent<IProps> {
    handleClick = () => {
        const { personId } = this.props;
        this.props.requestDeletePerson(personId);
    };

    render() {
        return (
            <SubmittingButton
                type="submit"
                namespace="PERSON_DELETE"
                negative
                fluid
                onClick={this.handleClick}
            >
                Delete
            </SubmittingButton>
        );
    }
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    null,
    { requestDeletePerson }
)(PersonDeleteModalButton);
